import { useEffect, useRef, useState } from 'react';
import Image from 'next/image';
import Link from 'next/link';

const FeaturedAuthors = ({ data, contentType, isMobile }) => {
  const [expanded, setExpanded] = useState(false);
  const containerRef = useRef(null);
  const [canClose, setCanClose] = useState(true);
  const authors = Array.isArray(data?.field_authors) ? data.field_authors : [];
  const closeT = useRef(null);

  useEffect(() => {
    const el = containerRef.current;
    if (!el || !isMobile) return;

    const observer = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];
        if (expanded && !entry.isIntersecting) {
          setExpanded(false);
        }
      },
      {
        threshold: 0,
      }
    );

    observer.observe(el);
    return () => observer.disconnect();
  }, [expanded, isMobile]);

  const canExpand = authors.length > 6;

  const handleExpandClick = () => {
    setExpanded(true);
  };
  const passthroughLoader = ({ src }) => src;

  const openFromButton = () => {
    if (isMobile || !canExpand) return;
    if (closeT.current) clearTimeout(closeT.current);
    setExpanded(true);
    setCanClose(false);
    setTimeout(() => setCanClose(true), 120);
  };

  const onLeave = () => {
    if (isMobile || !canExpand) return;
    if (!canClose) return;
    if (closeT.current) clearTimeout(closeT.current);
    closeT.current = setTimeout(() => setExpanded(false), 150);
  };
  return (
    <div
      className={`featuredAuthors ${contentType == 'author' ? 'fullWidthTemplate' : ''} ${expanded ? 'after' : ''}`}
      ref={containerRef}
      {...(!isMobile ? { onMouseLeave: onLeave } : {})}
    >
      <div className="inner-container">
        <div {...(!isMobile ? { onMouseLeave: onLeave } : {})}>
          <h5>{data?.field_title?.[0]?.value || data?.title}</h5>
          <div className="hr" />

          <div className={`authorsWrapper ${expanded ? 'expanded' : ''}`}>
            {authors.map((item, key) => {
              const isPlaceholder = !item?.field_author_photo?.webimage;
              const href = item['url-alias'] || '#';

              return (
                <div className="author" key={`author-${key}`}>
                  <Link
                    href={item['url-alias']}
                    className="author"
                    passHref
                    legacyBehavior
                  >
                    <a className="authorLink">
                      <div
                        className={`authorImageWrapper ${isPlaceholder ? 'isPlaceholder' : ''}`}
                      >
                        <Image
                          loader={isPlaceholder ? passthroughLoader : null}
                          src={
                            isPlaceholder
                              ? '/images/featured-author.png'
                              : item?.field_author_photo?.webimage
                          }
                          alt={
                            item?.field_author_full_name?.[0]?.value ||
                            item?.title ||
                            'Author'
                          }
                          layout="fill"
                          objectFit={isPlaceholder ? 'contain' : 'cover'}
                          objectPosition="center"
                          priority={key === 0}
                        />
                        <div className="overlay" />
                      </div>
                      <div className="authorName">
                        {item?.field_author_full_name?.[0]?.value ||
                          item?.title}
                      </div>
                      {/* <div className="authorTitle">
                      {item?.field_author_title?.[0]?.value}
                    </div> */}
                    </a>
                  </Link>
                </div>
              );
            })}
          </div>

          {canExpand && (
            <button
              className={`seeMoreBtn ${expanded ? 'hiddenButKeepsSpace' : ''}`}
              onClick={handleExpandClick}
              onMouseEnter={openFromButton}
              onFocus={openFromButton}
              disabled={expanded}
              tabIndex={expanded ? -1 : 0}
              aria-hidden={expanded ? 'true' : 'false'}
            >
              {data?.field_read_more_label?.[0]?.value || 'See more authors'}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default FeaturedAuthors;
